import { TBooleanInNumber } from 'src/types/main';
import { SORTING_DIRECTION } from 'src/constants/main';

export interface IUsersFilters {
  search: string;
  status: TBooleanInNumber[] | undefined;
  roles: number[] | undefined;
  perPage: number | undefined;
  sortField: USERS_SORT_COLUMN;
  sortDir: SORTING_DIRECTION;
}

export enum USERS_SORT_COLUMN {
  NAME = 'name',
  BRANCH = 'branch',
  ROLE = 'role',
  PHONE = 'mobile',
  LOGIN = 'username',
  EMAIL = 'email',
}

export interface IUserValidation {
  status: IDefaultUserFieldValidation;
  role: IDefaultUserFieldValidation;
  branches: IDefaultUserFieldValidation;
  franchises: IDefaultUserFieldValidation;
  name: IDefaultUserFieldValidation;
  username: IDefaultUserFieldValidation;
  email: IDefaultUserFieldValidation;
  password: IDefaultUserFieldValidation;
  mobile: IDefaultUserFieldValidation;
}

export interface IDefaultUserFieldValidation {
  state: boolean;
  errorText?: string;
}
